class DetailsModal extends HTMLElement {
	constructor() {
		super();
		this.header = document.querySelector(".header-wrapper");
		this.detailsContainer = this.querySelector("details");
		this.summaryToggle = this.querySelector("summary");
		this.header.preventHide = false;

		this.detailsContainer.addEventListener(
			"keyup",
			(event) => event.code === "Escape" && this.close()
		);
		this.summaryToggle.addEventListener(
			"click",
			this.onSummaryClick.bind(this)
		);
		this.querySelector('button[type="button"]').addEventListener(
			"click",
			this.close.bind(this)
		);

		this.summaryToggle.setAttribute("role", "button");
	}

	isOpen() {
		return this.detailsContainer.hasAttribute("open");
	}

	onSummaryClick(event) {
		event.preventDefault();
		if (event.target.closest("details").hasAttribute("open")) {
			this.close();
			this.header.preventHide = false;
		} else {
			this.open(event);
			if (!this.header) return;
			this.header.preventHide = this.detailsContainer.open;
		}
	}

	onBodyClick(event) {
		if (
			!this.contains(event.target) ||
			event.target.classList.contains("modal-overlay")
		)
			this.close(false);
	}

	open(event) {
		this.closeBurgerMenu();
		
		this.onBodyClickEvent =
			this.onBodyClickEvent || this.onBodyClick.bind(this);
		event.target.closest("details").setAttribute("open", true);
		document.body.addEventListener("click", this.onBodyClickEvent);
		document.body.classList.add("overflow-hidden");
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);

		trapFocus(
			this.detailsContainer.querySelector('[tabindex="-1"]'),
			this.detailsContainer.querySelector('input:not([type="hidden"])')
		);
	}

	close(focusToggle = true) {
		removeTrapFocus(focusToggle ? this.summaryToggle : null);
		this.detailsContainer.removeAttribute("open");
		document.body.removeEventListener("click", this.onBodyClickEvent);
		document.body.classList.remove("overflow-hidden");
		document.body.classList.remove(
			`overflow-hidden-${this.dataset.breakpoint}`
		);
		this.header.preventHide = false;
	}

	closeBurgerMenu () {
		// Close mega menu if it open.
		const burgerMenu = document.querySelector(".burger-menu--open");
		if (burgerMenu) {
			burgerMenu.classList.remove("burger-menu--open");
			burgerMenu.querySelector(".burger-menu__overlay")?.classList?.remove("burger-menu__overlay--active");
			document.body.classList.remove("overflow-hidden-drawer");
		}
	}
}

customElements.define("details-modal", DetailsModal);
class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (!this.detailsContainer || !this.summaryToggle) return;

    if (this.header) this.header.preventHide = false;

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.detailsContainer.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.detailsContainer.setAttribute('open', true);
    requestAnimationFrame(() => {
      this.detailsContainer.classList.add('menu-opening');
    });
    document.body.classList.add('overflow-hidden', 'overflow-hidden-tablet');
    if (this.header) this.header.preventHide = true;

    const focusTarget = this.detailsContainer.querySelector('[tabindex="-1"]');
    if (focusTarget) trapFocus(focusTarget);
  }

  close() {
    this.detailsContainer.classList.remove('menu-opening');
    setTimeout(() => {
      this.detailsContainer.removeAttribute('open');
    }, 300);
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet');
    if (this.header) this.header.preventHide = false;
    removeTrapFocus(this.summaryToggle);
  }
}

if (!customElements.get('header-drawer')) {
  customElements.define('header-drawer', HeaderDrawer);
}
